const actions = {
  GET_DALEEL_STORE_BALANCE_BEGIN: 'GET_DALEEL_STORE_BALANCE_BEGIN',
  GET_DALEEL_STORE_BALANCE_SUCCESS: 'GET_DALEEL_STORE_BALANCE_SUCCESS',
  GET_DALEEL_STORE_BALANCE_ERR: 'GET_DALEEL_STORE_BALANCE_ERR',

  GET_DALEEL_STORE_MERCHANTS_BEGIN: 'GET_DALEEL_STORE_MERCHANTS_BEGIN',
  GET_DALEEL_STORE_MERCHANTS_SUCCESS: 'GET_DALEEL_STORE_MERCHANTS_SUCCESS',
  GET_DALEEL_STORE_MERCHANTS_ERR: 'GET_DALEEL_STORE_MERCHANTS_ERR',

  GET_DALEEL_STORE_PRODUCTS_BEGIN: 'GET_DALEEL_STORE_PRODUCTS_BEGIN',
  GET_DALEEL_STORE_PRODUCTS_SUCCESS: 'GET_DALEEL_STORE_PRODUCTS_SUCCESS',
  GET_DALEEL_STORE_PRODUCTS_ERR: 'GET_DALEEL_STORE_PRODUCTS_ERR',

  getDaleelStoreBalanceBegin: () => {
    return {
      type: actions.GET_DALEEL_STORE_BALANCE_BEGIN,
    };
  },

  getDaleelStoreBalanceSuccess: (data) => {
    return {
      type: actions.GET_DALEEL_STORE_BALANCE_SUCCESS,
      data,
    };
  },

  getDaleelStoreBalanceErr: (err) => {
    return {
      type: actions.GET_DALEEL_STORE_BALANCE_ERR,
      err,
    };
  },

  getDaleelStoreMerchantsBegin: () => {
    return {
      type: actions.GET_DALEEL_STORE_MERCHANTS_BEGIN,
    };
  },

  getDaleelStoreMerchantsSuccess: (data) => {
    return {
      type: actions.GET_DALEEL_STORE_MERCHANTS_SUCCESS,
      data,
    };
  },

  getDaleelStoreMerchantsErr: (err) => {
    return {
      type: actions.GET_DALEEL_STORE_MERCHANTS_ERR,
      err,
    };
  },

  getDaleelStoreProductsBegin: () => {
    return {
      type: actions.GET_DALEEL_STORE_PRODUCTS_BEGIN,
    };
  },

  getDaleelStoreProductsSuccess: (data) => {
    return {
      type: actions.GET_DALEEL_STORE_PRODUCTS_SUCCESS,
      data,
    };
  },

  getDaleelStoreProductsErr: (err) => {
    return {
      type: actions.GET_DALEEL_STORE_PRODUCTS_ERR,
      err,
    };
  },
};

export default actions;
